export default __webpack_public_path__ + "static/media/singularity2045.8d9ce64e.webp";